import { useMutation } from 'react-query';
import { finishDemand } from 'src/services/api/demands';

function useFinishDemand() {
  return useMutation(({demand, comment}) => finishDemand(demand, { comment }) );
}

export default useFinishDemand;